import React, { useEffect, useState } from "react";
import { closeModal } from "redux/actions/global";
import { connect } from "react-redux";
import { getItemFromApi, newConvertedPrice, t } from "utils";
import getSymbolFromCurrency from "currency-symbol-map";
import ConditionLoader from "components/Loader/ConditionLoader";
import ArticlePrice from "components/ArticlePrice";
import Alert from "components/Alert";

const UpConditions = (props) => {
  const { closeModal, article, lang, profile } = props;
  const [responses, setResponses] = useState(article.condVentas);
  const [loading, setLoading] = useState(false);

  return (
    <div tabIndex="1" className="up-conditions-modal-ctn">
      <div className="up-conditions-modal-wrapper">
        <div className="up-conditions-modal-content">
          {/* Modal Header */}
          <div className="up-conditions-modal-header">
            <div className="header-title-ctn">
              <div className="header-title">{t("UP.conditions.title")}</div>
              <div className="close-modal" onClick={closeModal}>
                <img className="close-img" src="../images/UP/Close.png" alt="Close"></img>
              </div>
            </div>
            <div className="header-subtitle">{t("UP.conditions.subtitle")}</div>
          </div>
        </div>

        <div className="up-conditions-modal-table-ctn">
          <div className="up-conditions-modal-table">
            {loading ? (
              <ConditionLoader />
            ) : (
              <>
                {/* Article Information */}
                <div className="up-article-modal-ctn">
                  <div className="up-article-modal-wrapper">
                    <div className="up-article-modal-content">
                      <div className="up-article-img-ctn">
                        <img className="up-article-img" src={article.images[0].url} alt={article.title}></img>
                      </div>
                      <div className="up-article-desc">{article.title}</div>
                    </div>
                  </div>
                </div>

                {/* Conditions List */}
                <div className="up-article-conditions-ctn">
                  {responses.map((condition, index) => (
                    <div key={index} className="condition-ctn">
                      <div className="condition-wrapper">
                        <div className="condition-content-ctn">
                          <div className="condition-content">
                            <div className="condition-price">
                              {/* {getSymbolFromCurrency(condition.currency_id)}{" "}
                              {newConvertedPrice(condition.price, lang)} */}
                              <ArticlePrice className="price" article={condition} profile={profile} condVentas={true} />
                            </div>
                            
                          </div>

                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>

        <Alert alertType="warnCond" styleType="not-filled" className="alert__snack-translate-message">
          <div className="icon__container">
            <img alt="alert" className="alert-conditions" src="/images/alerts/caution.svg" />
          </div>
          <div className="content">{t("UP.conditions.alert")}</div>

        </Alert>
      </div>
    </div>
  );
};

const actions = {
  closeModal,
};

export default connect(null, actions)(UpConditions);
